import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../commonComponents/translate';
import { PRODUCT_STATUS } from '../../../shop/propTypes/productProp';
import StatusActive from './StatusActive';
import StatusDisabled from './StatusDisabled';

function ProductStatus(props) {
  const { t, status } = props;
  if (!status || status === PRODUCT_STATUS.NA) {
    return null;
  }

  const icon = useMemo(() => {
    switch (status) {
      case PRODUCT_STATUS.ACTIVE:
        return <StatusActive />;
      case PRODUCT_STATUS.DISABLED:
      default:
        return <StatusDisabled />;
    }
  }, [status]);

  return (
    <div className="product-status-container">
      <div className="product-status-icon">{icon}</div>
      <p className="product-status-text">{t(status)}</p>
    </div>
  );
}

ProductStatus.propTypes = {
  t: PropTypes.func.isRequired,
  status: PropTypes.string.isRequired,
};

export default translate(ProductStatus);
